import { InterviewProvider } from '@components/pass/interview/start/context/interviewContext';
import InterviewPracticeQuestionSelect from '../../../components/pass/interview/start';

const PassInterviewStartPage = () => {
  return (
    <InterviewProvider>
      <InterviewPracticeQuestionSelect />
    </InterviewProvider>
  );
};
export default PassInterviewStartPage;
